import { Button, Text, Select, Group } from "@mantine/core";
import React, { useState } from "react";
import { useServerApi } from "../../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import { openFileUrl } from "../../utils/openReport";

const DATA_REPORT_DATE_TYPE = [
  { label: "Create Date", value: "createdAt" },
  { label: "Notice Date", value: "date" },
  { label: "Effective Date", value: "period.start" },
  { label: "Expiry Date", value: "period.end" },
  { label: "Policy Received Date", value: "policyReceivedAt" },
  { label: "Policy Dispatched Date", value: "policyDispatchedAt" },
];

const ConsultantReportDebitNote = () => {
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [dateType, setDateType] = useState("date");
  const [loading, setLoading] = useState(false);
  const [api] = useServerApi();
  const { t } = useTranslation();
  const [policyStatus, setPolicyStatus] = useState(null);

  const DATA_POLICY_STATUS = [
    { label: "None", value: "NONE" },
    { label: "Policy Received", value: "POLICY_RECEIVED" },
    { label: "Policy Dispatched", value: "POLICY_DISPATCHED" },
  ];

  const canDownload = Boolean(dateType && (fromDate || toDate));

  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.DebitNote.getConsultantReport({
        fromDate,
        toDate,
        dateType,
        policyStatus,
      });
      setLoading(false);
      if (result?.data?.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs">{t("Please select the period of records")}</Text>
      <Group mt="xs">
        <DatePicker
          title="From"
          size="xs"
          allowFreeInput
          placeholder="From"
          disabled={!dateType}
          onChange={(d) => setFromDate(d)}
        />
        -
        <DatePicker
          title="To"
          size="xs"
          allowFreeInput
          placeholder="To"
          disabled={!dateType}
          onChange={(d) => setToDate(d)}
        />
        <Text size="xs">by</Text>
        <Select
          size="xs"
          data={DATA_REPORT_DATE_TYPE}
          clearable
          onChange={(type) => {
            setDateType(type);
            if (!type) {
              setFromDate(null);
              setToDate(null);
            }
          }}
        />
        <Select
          size="xs"
          data={DATA_POLICY_STATUS}
          onChange={(status) => setPolicyStatus(status ?? null)}
          clearable
          allowClear
        />
      </Group>
      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
        disabled={!canDownload}
      >
        {t("Download")}
      </Button>
      {!canDownload && (
        <Text size="xs" color="dimmed" mt="xs">
          {t("debitNote.report.dateRequired")}
        </Text>
      )}
    </div>
  );
};

export default ConsultantReportDebitNote;
